export default __webpack_public_path__ + "static/media/check_circle.c6ca6638.svg";